export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-transition-group/esm/config.js
// module id = 634
// module chunks = 0